/** Fixed templates owned by Retail Locations Product Catalogue. */
export enum RetailLocationsProductCatalogueWorkspaceCapabilityUdoTemplateKey {
    selection = "2ddbbf33-4dd0-4f47-b5af-34337bc5bdcc",
}
